<template>
    <div class="box">
      <p :style="{'background-color':color}" class="btn1 btn"></p>
      <p :style="{'background-color':color}" class="btn2 btn"></p>
      <p>{{name}}</p>
      <p :style="{'background-color':color}" class="btn2 btn"></p>
      <p :style="{'background-color':color}" class="btn1 btn"></p>
    </div>
</template>
<script>
    export default{
        data(){
            return {}
        },
        props: {
            name: String,
            color:{
                type: String,
                default: ()=>{
                    return 'rgb(243, 152, 0)'
                }
            }
        },
        methods: {},
        computed: {},
        mounted(){
        }
    }
</script>
<style scoped>
  .box{
    margin-left: 20px;
  }
  .box p{
    display: inline-block;
    font-size: 14px;
  }
  .btn{
    background-color: #00c261;
    /* padding: 5px; */
    border-radius: 50%;
    margin: 0 1px;
  }
  .btn1{
      /* animation: fade1 linear 1s infinite;
    animation-direction: alternate; */
    width: 10px;
    height: 10px
    }
  .btn2{
      width: 6px;
    height: 6px;
    position: relative;
    top: -2px;
    /* margin-top: -5px */
    /* animation: fade2 linear 1s infinite;
    animation-direction: alternate; */
  }
  /* @keyframes fade2 {
    0%{
      transform: scale(.5)
    }
    100%{
      transform: scale(.8)
    }
  }
  @keyframes fade1 {
    0%{
      transform: scale(.8)
    }
    100%{
      transform: scale(.5)
    }
  } */
</style>



// WEBPACK FOOTER //
// secondTitle.vue?e7342fd8